import { Pickup } from "./interfaces";

export const setSelectedPickup = ({ commit, dispatch, rootGetters }, pickup: Pickup) => {
  const activeVendor = rootGetters["vendor/getActiveVendor"];
  const cartSize = rootGetters["cart/getCartSize"];

  //Run calculate cart if there's an active vendor and items in the cart
  if (activeVendor && cartSize) dispatch("cart/validateCart", null, { root: true });
  commit("setSelectedPickup", pickup);
};

export const resetState = ({ commit }) => {
  commit("resetState");
};
